import styled from 'styled-components'

export default {
	Wrapper: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 54px 28px;
		gap: 32px;
	`,
	TypeList: styled.div`
		display: flex;
		flex-direction: column;
		gap: 20px;
	`,
	TypeChildren: styled.div`
		display: flex;
		flex-direction: column;
		gap: 12px;
		padding: 20px 0;
		border-top: 1px solid ${({theme}) => theme.color['black']};

		& > p {
			${({theme}) => theme.font['xsmall-medium']};
		}
	`,

	StoreElement: styled.div`
		display: flex;
		align-items: center;
		gap: 8px;
		padding-bottom: 12px;
		border-bottom: 1px solid ${({theme}) => theme.color['grey2']};

		& > img {
			width: 40px;
			min-width: 40px;
			height: 40px;
			object-fit: cover;
			object-position: center center;
			border-radius: 50%;
		}

		& > div {
			display: flex;
			flex-direction: column;
			gap: 2px;

			& > h2 {
				width: 100%;
				overflow: hidden;
				${({theme}) => theme.font['large-semibold']};
			}

			& > p {
				${({theme}) => theme.font['small-regular']};
			}
		}
	`,
	TicketElement: styled.div`
		display: flex;
		gap: 8px;
		padding-bottom: 12px;
		border-bottom: 1px solid ${({theme}) => theme.color['grey2']};

		& > div {
			display: flex;
			flex-direction: column;
			gap: 4px;

			& > h2 {
				width: 100%;
				overflow: hidden;
				${({theme}) => theme.font['large-semibold']};
				color: ${({theme, $deactive, $used}) =>
					$deactive && theme.color['grey3']};
				padding-bottom: 4px;

				& > span {
					position: relative;
					top: -3px;
					height: fit-content;
					${({theme}) => theme.font['xtiny-regular']};
					color: ${({theme}) => theme.color['white']};
					background-color: ${({theme}) => theme.color['black']};
					border-radius: 9999px;
					padding: 2px 8px;
					white-space: nowrap;
				}
			}

			& > p {
				${({theme}) => theme.font['xsmall-regular']};
				color: ${({theme, $deactive, $used}) =>
					$deactive && theme.color['grey3']};
			}
		}

		& > button {
			display: flex;
			align-items: center;
			gap: 4px;

			& > p {
				${({theme}) => theme.font['xsmall-semibold']};
				white-space: nowrap;
			}

			& > img {
				height: 8px;
			}
		}
	`,

	ModalDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 8px;
		margin: 16px 0 32px;
		padding: 24px 0;
		border-top: 1px solid ${({theme}) => theme.color['grey2']};
		border-bottom: 1px solid ${({theme}) => theme.color['grey2']};

		& > h2 {
			width: 100%;
			${({theme}) => theme.font['xxlarge-semibold']};
			word-break: break-word;
			text-align: center;
		}
	`,
	ModalArea: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;

		& > p {
			${({theme}) => theme.font['tiny-regular']};
			color: ${({theme}) => theme.color['grey4']};
			word-break: break-word;
		}

		& > h1 {
			text-align: center;
			${({theme}) => theme.font['small-regular']};
			word-break: break-word;
		}

		& > .countdown {
			${({theme}) => theme.font['small-semibold']};
			color: ${({theme}) => theme.color['black']};
		}
	`,
	QRControls: styled.div`
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 12px;
		gap: 12px;

		& > .countdown-text {
			${({theme}) => theme.font['small-regular']};
			color: ${({theme}) => theme.color['grey4']};
			margin: 0;
		}
	`,
	RefreshButton: styled.button`
		${({theme}) => theme.font['xtiny-semibold']};
		padding: 6px 12px;
		background-color: ${({theme}) => theme.color['black']};
		color: ${({theme}) => theme.color['white']};
		border: none;
		border-radius: 4px;
		cursor: pointer;
		transition: opacity 0.2s;

		&:hover {
			opacity: 0.8;
		}

		&:active {
			opacity: 0.6;
		}
	`,
}
